import { render, staticRenderFns } from "./CustomersLogos.vue?vue&type=template&id=61b10b7b&scoped=true&"
import script from "./CustomersLogos.vue?vue&type=script&lang=js&"
export * from "./CustomersLogos.vue?vue&type=script&lang=js&"
import style0 from "./CustomersLogos.vue?vue&type=style&index=0&id=61b10b7b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b10b7b",
  null
  
)

export default component.exports